@if (gameLoaded) {
<div>
  <h2>@if (gameEngineService.isPrivateRoom) {
    <i class="fa fa-key"></i>
    } {{gameEngineService.roomName}}
  </h2>
  <br>
  @if (gameInactive) {
  <h3>{{ i18n.str('challengeu.room_game_deactivated', 'Game has been deactivated')() }}</h3>
  <p class="jeopardy-button secondary" style="margin-right: 1em;">
    <a href="#" routerLink="/multiplayer">{{ i18n.str('challengeu.back', 'Back')() }}</a>
  </p>
  }
  @if (!gameInactive && players.length) {
  @for (player of players; track player) {
  <div style="display: flex;justify-content: center; gap: 3em;">
    <div>
      <img src="assets/app-branding/img/avatars/cartoon/{{player.avatar}}" style="width: 4em;"
           [alt]="i18n.str('challengeu.main_avatar', 'Your avatar picture')()">
    </div>
    <div class="centered">
      {{player.name}}
    </div>
    <!-- <div>
            <p class="jeopardy-button primary" style="margin-right: 1em;">
              <a href="#" routerLink="/multiplayer">Approve</a>
            </p>
            <p class="jeopardy-button secondary" style="margin-right: 1em;">
              <a href="#" routerLink="/multiplayer">Deny</a>
            </p>
          </div> -->
  </div>
  }
  @if (!gameStarted) {
  <h3 style="margin-top: 3em;">
    {{ i18n.str('challengeu.room_game_will_start', 'Game will start in')() }}: {{counter}}
  </h3>
  }
  @if (gameStarted) {
  <p>
    {{ i18n.str('challengeu.room_game_started', 'Game started')() }}
  </p>
  }
  <!-- <p class="jeopardy-button primary" *ngIf="gameStarted">
      <a href="#">Go to game</a>
    </p> -->
  <p class="jeopardy-button primary" style="margin-right: .5em;">
    <a href="#" routerLink="/multiplayer">{{ i18n.str('challengeu.mp_rooms_return_room_list', "Return to room list")()
      }}</a>
  </p>
  }
</div>
}
